export default "__VITE_ASSET__d35c8853__"